import { CheckCircle2 } from "lucide-react";

export const AUDIO_ACCEPT = ".wav,.aif,.aiff,.flac,.mp3,.aac,.m4a,.mp4,.mov,.mxf,.mkv,audio/*,video/mp4,video/quicktime";
export const VIDEO_ACCEPT = ".mp4,.mov,.mxf,.mkv,.m4v,video/*";
export const MODES = [["fast", "MVSep Cinematic — FAST", "Single pass. Fastest turnaround."], ["hq", "MVSep Cinematic — HQ", "Test-time augmentation. ~2× GPU time."],
  ["both", "Both Fast + HQ", "Two runs on the same master — compare quality and processing time."]];
export const MELAB_MODE = ["melab", "M&E Lab — experimental", "For M&E-only inputs (no dialogue). HQ separation, then two anchored pairs from one pass: MX1/FX1 (music-anchored: FX = master − music) and MX2/FX2 (effects-anchored: MX = master − effects). Each pair sums to the master sample-exactly. ~2× GPU time."];
export const GAUDIO_MODE = ["gaudio", "Gaudio GSEP — Premium", "Gaudio vendor API, run from the GPU worker. Cleaner dialogue / music overlaps. Billed per minute of audio (+ a few minutes of GPU time) — admin only."];
export const inputCls = "mt-1 w-full bg-[#0B0E14] border border-[#253044] rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:border-cyan-500";

export const Step = ({ n, title, children, done }) => (
  <section className="panel p-5 md:p-6 space-y-4">
    <div className="flex items-center gap-3">
      <span className={`h-7 w-7 rounded-full grid place-items-center text-xs font-bold ${done ? "bg-emerald-500 text-black" : "bg-[#1E2738] text-slate-300"}`}>{done ? <CheckCircle2 size={15} /> : n}</span>
      <h2 className="font-display text-base md:text-lg font-semibold">{title}</h2>
    </div>
    {children}
  </section>
);

export const ModeCards = ({ cards, mode, onPick }) => (
  <div className={cards.length > 3 ? "grid sm:grid-cols-2 lg:grid-cols-4 gap-2" : "grid sm:grid-cols-3 gap-2"}>
    {cards.map(([v, l, d]) => (
      <button key={v} data-testid={`mode-${v}`} onClick={() => onPick(v)} className={`text-left rounded-sm border p-3 transition-colors ${mode === v ? (v === "gaudio" ? "border-amber-400 bg-amber-500/10" : "border-cyan-500 bg-cyan-500/10") : "border-[#253044] hover:bg-[#1E2738]"}`}>
        <div className="text-sm font-semibold">{l}</div><div className="text-[11px] text-slate-400 mt-1">{d}</div>
      </button>
    ))}
  </div>
);

// "Show_S01E07.wav", "UKA 35.mp4", "Ep-12_final.mov" -> episode number guess
export const guessEpisodeNumber = (filename) => {
  const base = filename.replace(/\.[^.]+$/, "");
  const m = base.match(/(?:^|[\s_\-.])(?:ep(?:isode)?|e)[\s_\-.]?0*(\d{1,3})(?!\d)/i) || base.match(/(?:^|[\s_\-.])0*(\d{1,3})(?=$|[\s_\-.])/);
  return m ? m[1] : "";
};

export const guessEpisodeName = (filename) => filename.replace(/\.[^.]+$/, "").replace(/[\s_\-.]*(?:ep(?:isode)?|e)?[\s_\-.]?\d{1,3}[\s_\-.]*(final|mix|master)?$/i, "").replace(/[_.]+/g, " ").trim();
